import React from "react";
import { Link } from "react-router-dom";
import ImageThumb from "@/components/ImageThumb";
import AuthBadge from "@/components/AuthBadge";
import { RepRow } from "@/components/SellerRep";
import { ERA_LABELS, FABRIC_TYPE_LABELS } from "@/lib/taxonomy";

export default function ProductCard({ item, testid }) {
  const price = Number(item.price).toFixed(2);
  const reduced = item.is_reduced && item.original_price > item.price;
  const era = item.era && item.era !== "unspecified" ? ERA_LABELS[item.era] : null;
  const isFabric = item.category === "fabric_archives";
  const eyebrow = isFabric
    ? (FABRIC_TYPE_LABELS[item.product_type] || item.product_type)
    : `${item.brand || item.product_type} · ${item.gender}`;
  return (
    <Link
      to={`/product/${item.id}`}
      data-testid={testid || `product-card-${item.id}`}
      className="group block hairline card-lift bg-white"
    >
      <div className="relative aspect-[4/5] bg-neutral-50 overflow-hidden">
        <ImageThumb
          path={item.image_paths?.[0]}
          alt={item.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {item.demo_sold_out && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/45 backdrop-blur-[1px]"
            data-testid={`sold-out-overlay-${item.id}`}>
            <span className="px-4 py-1.5 text-[0.62rem] uppercase tracking-[0.28em] font-medium bg-white text-black">
              Sold Out
            </span>
          </div>
        )}
        <div className="absolute left-2 top-2 flex flex-col items-start gap-1">
          {item.just_in && (
            <span className="px-1.5 py-0.5 text-[0.55rem] uppercase tracking-[0.16em] font-medium"
              style={{ background: "#1E3A2B", color: "#fff" }} data-testid={`just-in-chip-${item.id}`}>Just In</span>
          )}
          {item.boosted && (
            <span className="px-1.5 py-0.5 text-[0.55rem] uppercase tracking-[0.16em] font-medium"
              style={{ background: "#2563EB", color: "#fff" }} data-testid={`featured-chip-${item.id}`}>Featured</span>
          )}
          {era && (
            <span className="bg-white/90 backdrop-blur px-1.5 py-0.5 text-[0.55rem] uppercase tracking-[0.16em]"
              data-testid={`era-chip-${item.id}`}>{era}</span>
          )}
          <AuthBadge item={item} compact testid={`card-auth-${item.id}`} />
        </div>
      </div>
      <div className="p-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="label-eyebrow truncate">{eyebrow}</div>
          <div className="mt-1 font-display text-base truncate">{item.title}</div>
          <div className="mt-1 text-xs text-neutral-500 truncate">{item.color} · {item.pattern}</div>
          {(item.seller_good > 0 || item.seller_bad > 0 || item.seller_verified_sales > 0) && (
            <div className="mt-1.5" data-testid={`card-seller-rating-${item.id}`}>
              <RepRow good={item.seller_good} bad={item.seller_bad} verified={item.seller_verified_sales} size={11} />
            </div>
          )}
        </div>
        <div className="text-right shrink-0">
          {reduced && <div className="text-[0.65rem] line-through text-neutral-400">${Number(item.original_price).toFixed(2)}</div>}
          <div className="font-display text-base" style={reduced ? { color: "#2563EB" } : {}}>${price}</div>
        </div>
      </div>
    </Link>
  );
}
